import React from 'react';
export function Footer() {
  return;
}